/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, IconButton, Typography} from "@mui/material";
import logo from '../Recursos/logo_blanco.svg'
import {CONTACTOS, POLITICAS, REDES, SECCIONES} from "../Constantes";
import {irUrl} from "../Utilidades/irUrl";
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";
import {useDialogo} from "../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "./Dialogos/Dialogo_Politicas";
import {useIrRuta} from "../Utilidades/useIrRuta";


const Footer = () => {
    const {sCell} = useResponsive()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})
    const {ir} = useIrRuta()


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#3D4724',
                py: 8
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, py: 2, color: '#fff'}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 4, md: 4}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={250} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 3}}>
                            <Typography sx={{fontSize: 18}}>Cultivamos más que café, cultivamos conexión con la tierra y
                                su
                                gente.</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            spacing={2}
                            sx={{mt: 2}}
                        >

                            {REDES.map((item, i) => {
                                return (
                                    <IconButton
                                        onClick={() => irUrl(item.url)}
                                    >
                                        <img src={item.img} width={40} height={'auto'}/>
                                    </IconButton>
                                )
                            })}

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 4, md: 2}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600, fontSize: 18}}>Links Rapidos</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                        >

                            {SECCIONES.map((item, i) => {
                                return (
                                    <Grid

                                        container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography
                                            onClick={() => ir(item)}
                                            sx={{fontWeight: 400, fontSize: 18,cursor: 'pointer'}}>{item}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600, fontSize: 18}}>Politicas</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                        >

                            {POLITICAS.map((item, i) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography
                                            onClick={() => abrir(item)}
                                            sx={{
                                                fontWeight: 400,
                                                fontSize: 18,
                                                cursor: 'pointer'
                                            }}>{item.nombre}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 4, md: 3}} sx={{justifyContent: 'flex-start', mt: sCell ? 4 : 0}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={0}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontWeight: 600, fontSize: 18}}>Contactos</Typography>
                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}}
                            sx={{mt: 4}}
                        >

                            {CONTACTOS.map((item, i) => {
                                return (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography sx={{fontWeight: 400, fontSize: 18}}>{item.descripcion}</Typography>
                                    </Grid>
                                )
                            })}

                        </Grid>

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', px: 2, color: '#fff', mt: 3, mb: -6}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Typography sx={{textAlign: 'center'}}>© Copyright 2025 - 2026 | CI ORIGENES COFFEE SAS
                            ZOMAC</Typography>

                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Footer